import React          from 'react';
import ConfigProvider from 'antd/lib/config-provider';

const COMPACT = { controlHeight: 32 };

/** Hauteur ordinaire des champs et boutons, là où `LeftSidebar` les passe à 40px. */
export default function CompactControls({ children }: { children: React.ReactNode; }) {
	return (
		<ConfigProvider
			theme={{
				components: {
					Input: COMPACT,
					InputNumber: COMPACT,
					Select: COMPACT,
					DatePicker: COMPACT,
					Button: COMPACT,
				},
			}}
		>
			{children}
		</ConfigProvider>
	);
}
